import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { CreateService } from 'src/app/services/create.service';

@Component({
  selector: 'app-assign-shared-folder',
  templateUrl: './assign-shared-folder.component.html',
  styleUrls: ['./assign-shared-folder.component.scss']
})
export class AssignSharedFolderComponent {
  emailIds: string = '';
  driveId: string = '';
  isError: boolean = false;
  errorMessage: string = '';
  isSuccess: boolean = false;
  successMessage: string = '';
  closeDialog: boolean = false;
  userEmailId = this.storage.retrieve("userEmailId");

  constructor(private createService: CreateService, private storage: LocalStorageService, private dialogRef: MatDialog) {
  }

  getContentBySearch() {
    this.isError = false;
    this.isSuccess = false;
    this.createService.getContentBySearch(this.emailIds, this.driveId, this.userEmailId).subscribe({
      next: (data: any) => {
        if (data && data != 'Success') {
          this.isError = true;
          this.errorMessage = data;
        } else {
          this.isSuccess = true;
          this.successMessage = data;
          setTimeout(() => {
            this.isSuccess = false;
            this.successMessage = '';
            this.emailIds = '';
            this.driveId = '';
            this.closeDialog = true;
            this.dialogRef.closeAll();
          }, 3000);
        }
      },
      error: (e: any) => {
      }
    })
  }
}
